import React from 'react';
import { Link as CoreLink } from 'localmed-core';

import isFullNavigation from '../../utils/fullNavigation';

export default function Link(props) {
  return <CoreLink {...props} fullNavigation={isFullNavigation(props.to)} />;
}
